<template>
  <div class="survey-report">
    <div class="md-layout-item md-size-100 md-layout p-0">
      <div
        v-for="(question, index) in surveyQuestions"
        :key="'question' + index"
        class="md-layout-item md-size-100 md-layout p-0"
      >
        <div class="md-layout-item md-size-100 question-text flex">
          <span :class="{ 'mark-required': question.require }" class="mr-2"
            >{{ index + 1 }}.</span
          >
          <span v-html="question.question"></span>
        </div>
        <div
          v-if="question.subtext"
          class="md-layout-item md-size-100 question-subtext"
        >
          {{ question.subtext }}
        </div>
        <div
          v-if="question.type === type.checkbox"
          class="md-layout-item md-size-100"
        >
          <div
            v-for="(choice, index1) in question.choices"
            :key="'checkbox' + index1 + index"
          >
            <md-checkbox
              v-model="userAnswers[index]"
              :value="choice.text"
              disabled
              ><span class="text-[#242424]">{{
                choice.text
              }}</span></md-checkbox
            >
          </div>
        </div>
        <div
          v-if="question.type === type.radio"
          class="md-layout-item md-size-100 p-0"
        >
          <div
            v-for="(choice, index1) in question.choices"
            :key="'radio' + index1 + index"
          >
            <md-radio v-model="userAnswers[index]" :value="choice.text" disabled
              ><span class="opacity-100 text-[#242424]">{{
                choice.text
              }}</span></md-radio
            >
          </div>
        </div>
        <div
          v-if="question.type === type.dropdown"
          class="md-layout-item md-size-100"
        >
          <md-field class="w-[350px]">
            <md-select v-model="userAnswers[index]" disabled>
              <md-option
                v-for="(choice, index1) in question.choices"
                :key="'dropdown' + index1 + index"
                :value="choice.text"
                >{{ choice.text }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div
          v-if="question.type === type.singleLineText"
          class="md-layout-item md-size-100"
        >
          <md-field>
            <md-input
              v-model="userAnswers[index]"
              class="bg-[#fff]"
              disabled
            ></md-input>
          </md-field>
        </div>
        <div
          v-if="question.type === type.multiLineText"
          class="md-layout-item md-size-100"
        >
          <md-field class="bg-[#fff]">
            <md-textarea v-model="userAnswers[index]" disabled></md-textarea>
          </md-field>
        </div>
      </div>
    </div>
    <div class="flex justify-center">
      <md-button class="md-raised" @click="hideModal"
        >{{ $t("common.close") }}
      </md-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: ["reportDetail", "surveyQuestions", "modalName"],
  data() {
    const type = {
      dropdown: "drop_down_list",
      radio: "radio_button",
      checkbox: "checkbox",
      singleLineText: "single_line_text",
      multiLineText: "multi_line_text"
    };
    return {
      type,
      userAnswers: []
    };
  },
  created() {
    this.renderUserAnswerList();
  },
  methods: {
    hideModal() {
      this.$modal.hide(this.modalName);
    },
    renderUserAnswerList() {
      this.userAnswers = this.reportDetail.answers.map(item => {
        if (item.type === this.type.checkbox) {
          return [...item.answer];
        } else {
          return item.answer;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.survey-report {
  .question-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 26px;
    letter-spacing: 0.1px;
    color: #242424;
    padding: 0;
  }

  .question-subtext {
    font-weight: 400;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.1px;
    color: #242424;
    padding: 0;
  }

  .md-checkbox.md-disabled .md-checkbox-label {
    opacity: 1 !important;
  }

  .mark-required::after {
    content: "*";
    color: red;
  }

  .md-radio.md-disabled .md-radio-label,
  .md-radio.md-disabled .md-radio-container {
    opacity: 1 !important;
  }
}
</style>
